import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
} from 'reactstrap'

import { personalFields } from '../../order-fields'
import EditRegular from '../../icons/EditRegular'

const CustomerDetails = props => {
  const { errors, handleBlur, handleChange, touched, values } = props
  const [isStaticMode, setIsStaticMode] = useState(false)
  useEffect(() => {
    const fieldNames = personalFields.map(field => field.name)
    if (!!values && fieldNames.filter(field => !values[field]).length === 0) {
      setIsStaticMode(true)
    }
  }, [])
  if (isStaticMode) {
    return (
      <div className="pl-2">
        <div>
          {values.customer_firstname} {values.customer_lastname}
        </div>
        <div>{values.phone}</div>
        <div>{values.email}</div>
        <button
          type="button"
          className="btn mt-2 oto-btn-inline"
          onClick={() => setIsStaticMode(false)}
        >
          <EditRegular /> zmień dane kontaktowe
        </button>
      </div>
    )
  }
  return (
    <>
      {personalFields.map(field => (
        <FormGroup key={field.name} className="col-12 col-md-6">
          <Label>{field.label}</Label>
          {field.addon ? (
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>{field.addon}</InputGroupText>
              </InputGroupAddon>
              <Input
                type={field.type || 'text'}
                valid={touched[field.name] && !errors[field.name]}
                invalid={touched[field.name] && !!errors[field.name]}
                name={field.name}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values[field.name]}
              />
              <FormFeedback>{errors[field.name]}</FormFeedback>
            </InputGroup>
          ) : (
            <>
              <Input
                type={field.type || 'text'}
                valid={touched[field.name] && !errors[field.name]}
                invalid={touched[field.name] && !!errors[field.name]}
                name={field.name}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values[field.name]}
              />
              <FormFeedback>{errors[field.name]}</FormFeedback>
            </>
          )}
        </FormGroup>
      ))}
    </>
  )
}

CustomerDetails.propTypes = {
  errors: PropTypes.object.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
}

export default CustomerDetails
